import { render, staticRenderFns } from "./DenseInterface.vue?vue&type=template&id=6db48e0a&scoped=true&"
import script from "./DenseInterface.vue?vue&type=script&lang=ts&"
export * from "./DenseInterface.vue?vue&type=script&lang=ts&"
import style0 from "./DenseInterface.vue?vue&type=style&index=0&id=6db48e0a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db48e0a",
  null
  
)

export default component.exports